module.exports = __webpack_public_path__ + "static/nutcracker-84dd37ddb26c94cfc5ea9db268a17adf.png";